import { WORKFLOW_TRIGGERS } from 'modules/workflows/constants';

export const EVENT_TYPE_TRIGGER_SELECT = 'basic-filter-select-event-type-trigger';
export const EVENT_RESOURCE_FIELD_TRIGGER_SELECT = 'event-resource-field-select-trigger';
export const EVENT_RESOURCE_FIELD_READ_ONLY_TOOLTIP = 'read-only-event-resource-field-tooltip';
export const EVENT_RESOURCE_FIELD_ID = 'event-resource-field-trigger-data';
export const EVENT_RESOURCE_FIELD_VIEW_LIST_LINK = 'event-resource-field-view-list-link';

export const getFilteredTriggerList = (featureFlags: Record<string, boolean> = {}) => {
  const {
    SendEmailTrigger = false,
    JourneySubscribeEntrySource = false,
    JourneyNewUserEntrySource = false,
    WhatsAppMessageChannel = false,
    WhatsAppMessageChannelGA = false,
  } = featureFlags;

  return [
    // in order as now we need them categorized
    WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT,
    ...(JourneyNewUserEntrySource ? [WORKFLOW_TRIGGERS.NEW_USER_CREATED] : []),
    WORKFLOW_TRIGGERS.ADDED_ITEM_TO_CART,
    WORKFLOW_TRIGGERS.PURCHASED,
    WORKFLOW_TRIGGERS.FIELD_CHANGED,
    ...(JourneySubscribeEntrySource ? [WORKFLOW_TRIGGERS.SUBSCRIBED_TO_CHANNEL] : []),
    WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_CHANNEL,
    WORKFLOW_TRIGGERS.SUBSCRIBED_TO_LIST,
    WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_LIST,
    ...(JourneySubscribeEntrySource ? [WORKFLOW_TRIGGERS.SUBSCRIBED_TO_MESSAGE_TYPE] : []),
    WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_MESSAGE_TYPE,
    WORKFLOW_TRIGGERS.CLICKED_AN_EMAIL,
    WORKFLOW_TRIGGERS.OPENED_AN_EMAIL,
    ...(SendEmailTrigger ? [WORKFLOW_TRIGGERS.SEND_AN_EMAIL] : []),
    WORKFLOW_TRIGGERS.CLICKED_AN_IN_APP,
    WORKFLOW_TRIGGERS.OPENED_AN_IN_APP,
    WORKFLOW_TRIGGERS.OPENED_PUSH,
    WORKFLOW_TRIGGERS.CLICKED_AN_SMS,
    WORKFLOW_TRIGGERS.RECEIVED_AN_SMS,
    ...(WhatsAppMessageChannel || WhatsAppMessageChannelGA
      ? [WORKFLOW_TRIGGERS.CLICKED_A_WHATSAPP, WORKFLOW_TRIGGERS.RECEIVED_A_WHATSAPP]
      : []),
  ];
};
